$(function () {
    $('.small-img').on({
        'click': function(e){
            let small_img = e.target.src;
            let big_img = $('#big-img').get(0).src
            e.target.src = big_img;
            $('#big-img').get(0).src = small_img;
            $('#popup-img').get(0).src = small_img;
        }
    });

    $('#big-img').on('click', (event) => {
        if ($('#popup-img').is(":visible")) {
            $('#popup-img').hide();
        } else {
            $('#popup-img').show();
        }
    });

    window.addEventListener('click', (event) => {
        console.log();
        if (event.target.id != 'big-img') {
            if ($('#popup-img').is(":visible")) {
                $('#popup-img').hide();
            }
        }
    })
});